import axios from "../api/axiosInstance";
import { selectProject } from "../features/projects/ProjectSlice";
import { resetAllState } from "../features/replayslice";
// Project APIs are now imported directly from project_apis.js in components
import { login as loginApi, logout as logoutApi, getCurrentLoggedInUser, refreshSession as refreshSessionApi } from "./api/auth_apis";
import { getTestCaseList, getTestCaseDetail, getAllTestCaseData, fetchModulesWithCount as fetchModulesWithCountApi, bulkCreateTestCase, createTestCase as createTestCaseApi, updateTestCase as updateTestCaseApi, updateTestCaseField as updateTestCaseFieldApi, fetchExecutionHistory, deleteTestCase as deleteTestCaseApi, cloneTestCase as cloneTestCaseApi, moveTestCase as moveTestCaseApi } from "./api/testcase_api";
// Label APIs are now imported directly from label_apis.js in components
import { getModules as getModulesApi, createModule as createModuleApi, updateModule as updateModuleApi, deleteModule as deleteModuleApi, getModuleNames as getModuleNamesApi, getLevel1Modules as getLevel1ModulesApi, getChildModules as getChildModulesApi } from "./api/module_apis";
import { STATUS, getProjectId } from "./api/sharedfunction";
import { 
    checkExecutionPlanExists as checkExecutionPlanExistsApi, 
    getExecutionResult as getExecutionResultApi, 
    updateExecutionResultStatus as updateExecutionResultStatusApi,
    getAutomationInstruction as getAutomationInstructionApi,
    checkAutomationInstruction as checkAutomationInstructionApi,
    getExecutionRecord as getExecutionRecordApi,
    updateExecutionRecord as updateExecutionRecordApi,
    updateAutomationInstruction as updateAutomationInstructionApi,
    saveAutomationInstructionOnly as saveAutomationInstructionOnlyApi
} from "./api/auto-execution_apis";

// fetchProjects removed - use getProjectsList from project_apis.js directly
// fetchUserPreferences removed - use fetchUserPreferences from userPreference_apis.js directly
// updateUserPreferences removed - use updateUserPreferences from userPreference_apis.js directly

export const fetchUserLogin = async () => {
    try {
        const response = await getCurrentLoggedInUser();
        if(response.status === STATUS.SUCCESS && response.data) {
            return {
                status: 1,
                data: response.data
            };
        }
        return {
            status: 0,
            data: null
        };
    } catch (error) {
        console.error("Error fetching user login:", error);
        return {
            status: -1,
            error: error?.error || 'Something went wrong!'
        };
    }
}

export const logoutUserApiCall = async () => {
    try {
        await logoutApi();
    } catch (error) {
        console.error("Error logging out:", error);
    }
}
export default async function fetchTestRuns({page=1, pageSize=10, filter, order=[]}){
    try{
        const responce = await axios.get(`${process.env.REACT_APP_API_URL}/testrun/get`, {
            params: {
                pageSize: pageSize,
                page: page,
                filter: filter,
                order: order
            }
        });
        return {
            data: responce?.data?.data || [],
            metainfo: responce?.data?.metainfo || {
                totalCount: 0,
                page: 0
            }
        };
        responce?.data?.data || [];
    } catch(error){
        console.error("Error fetching test runs:", error);
        return {
            data: [],
            metainfo: {
                totalCount: 0,
                page: 0
            }
        };
    }
}

export async function deleteTestRunsApiCall(id){
    try {
            const responce = await axios.delete(`${process.env.REACT_APP_API_URL}/testrun/${id}`);
            if(responce.data.status=== "Pass"){
                return {
                    status: 1
                }
            }
            return {
                status: 0
            }
        } catch (error) {
           return {
                status: -1,
                error: error || 'Something went wrong!'
            }
        }
}

export async function fetchAllTestCaseData({
    testCaseId = null,
    testCaseName = null,
    testCaseTitle = null,
    page = 1,
    limit = 15,
    onlyExecutionRecord = false,
    onlyInstructionAvailable = false,
    signal = null
} = {}) {
    try {
        const response = await getAllTestCaseData({
            testCaseId,
            testCaseName,
            testCaseTitle,
            page,
            limit,
            onlyExecutionRecord,
            onlyInstructionAvailable,
        });
        
        if (response.status === STATUS.SUCCESS) {
            return {
                status: 1,
                data: response.data || {}
            };
        }
        
        return {
            status: -1,
            error: response.error || 'Error fetching test cases'
        };
    } catch (error) {
        console.error("Error fetching all test case data:", error);
        return {
            status: -1,
            error: error?.error || error?.message || 'Error fetching test cases'
        };
    }
}

export async function bulkDeleteTestRunsApiCall(ids){
    try {
        const responce = await axios.delete(`${process.env.REACT_APP_API_URL}/testrun/bulkdelete`, {
            data: {testrunIds: ids}
        });
        if(responce.data.status=== "Pass"){
            return {
                status: 1
            }
        }
        return {
            status: 0
        }
    } catch (error) {
       return {
            status: -1,
            error: error || 'Something went wrong!'
        }
    }
}

export async function cloneTestRunApiCall({testRunId, data}){
    try {
        const responce = await axios.post(`${process.env.REACT_APP_API_URL}/testrun/clonetestrun/${testRunId}`, {
            data
        });
        if(responce.data.success){
            return {
                status: 1
            }
        }
        return {
            status: -1,
            error: responce.data.error || 'Something went wrong!'
        }
    } catch (error) {
       return {
            status: -1,
            error: error?.response?.data?.error || 'Something went wrong!'
        }
    }
}

export async function fetchTestRunData({selectedTestrunID=null}) {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/testrun/getTestrun`,
            {
              params: { id: selectedTestrunID },
            }
        );

        return response.data || {}
    } catch(error){
        console.error("Error fetching test run data:", error);
        return {
            data: [],
            metainfo: {
                totalCount: 0,
                page: 0
            }
        };
    }
}

export async function fetchModuleNames({uIds}) {
    try {
        const result = await getModuleNamesApi({ ids: uIds });
        if (result.status === STATUS.SUCCESS) {
            return result.data || [];
        }
        return [];
    } catch (error) {
        console.error("Error fetching module names:", error);
        return [];
    }
}

export async function fetchTestCases({
    page = null,
    pageSize = null,
    selectedModuleId = 'default',
    selectedTestrunID = null,
    sortField = 'created_at',
    sortOrder = 'desc',
    filterField = null,
    filterOperator = null,
    filterValue = null
}) {
    try {
        const responce = await axios.get(`${process.env.REACT_APP_API_URL}/testrun/getTestCases`, {
            params: {
                page,
                pageSize,
                selectedModuleId,
                selectedTestrunID,
                sortField,
                sortOrder,
                filterField,
                filterOperator,
                filterValue
            }
        });
        return responce.data || [];
    } catch (error) {
        console.error("Error fetching test cases:", error);
    }
}

export async function fetchModulesTreeViewData(){
    try {
        const result = await getModulesApi();
        if (result.status === STATUS.SUCCESS) {
            return result.data || [];
        }
        return [];
    } catch (error) {
        console.error("Error fetching module tree view:", error);
        return [];
    }
}

export async function createModuleApiCall(data){
    try {
        const result = await createModuleApi(data);
        if (result.status === STATUS.SUCCESS) {
            return {
                status: 1,
                data: result.data
            };
        }
        return {
            status: -1,
            data: null,
            message: result.error || 'Something went wrong!',
            error: result.error || 'Something went wrong!'
        };
    } catch (error) {
       return {
            status: -1,
            message: error?.message || 'Something went wrong!',
            error: error?.error || 'Something went wrong!'
        };
    }
}

export async function editModuleApiCall({id, data}){
    try {
        const result = await updateModuleApi({ id, ...data });
        if (result.status === STATUS.SUCCESS) {
            return {
                status: 1,
                data: result.data
            };
        }
        return {
            status: -1,
            data: null,
            error: result.error || 'Something went wrong!'
        };
    } catch (error) {
       return {
            status: -1,
            error: error?.error || error?.message || 'Something went wrong!'
        };
    }
}

export async function deleteModuleApiCall(id){
    try {
            const result = await deleteModuleApi({ id });
            if (result.status === STATUS.SUCCESS) {
                return {
                    status: 1,
                    message: result.message
                };
            }
            return {
                status: -1,
                error: result.error || 'Something went wrong!'
            };
        } catch (error) {
           return {
                status: -1,
                error: error?.error || error?.message || 'Something went wrong!'
            };
        }
}

export async function fetchTestCaseHistory({testCaseId=null, page=1, pageSize=25, sort=[], order=[]}){
    try{
        if(!testCaseId){
            return {
                status: -1,
                error: 'Test case ID is required'
            }
        }
        const projectId = getProjectId();
        if (!projectId) {
            return {
                status: -1,
                error: 'Project ID is required'
            };
        }
        
        const responce = await axios.get(`${process.env.REACT_APP_API_URL}/${projectId}/testcase/getTestCaseHistory/${testCaseId}`, {
            params: {
                page,
                pageSize,
                sort,
                order
            },
            withCredentials: true
        });
        return {
            status: 1,
            data: responce?.data || []
        }
    } catch (error) {
        console.error("Error fetching test case history:", error);
        return {
            status: -1,
            error: 'Error fetching test case history'
        }
    }
}

export async function fetchTestCaseScenario({testCaseId=null}){
    try{
        if(!testCaseId) return {
            status: -1,
            error: 'Test case ID is required'
        }
        const responce = await axios.get(`${process.env.REACT_APP_API_URL}/testcaseAutomation/executionScenario/${testCaseId}`);
        return responce.data || [];
    } catch (error) {
        console.error("Error fetching test case scenario:", error);
        return {
            status: -1,
            error: 'Error fetching test case scenario'
        }
    }
}

export async function updateTestCaseScenario({testCaseId=null, data=null}){
    try{
        if(!testCaseId ) return {
            status: -1,
            error: 'Test case ID is required'
        }
        const payload = {
            testCaseId: testCaseId,
            executionScenario: data
        }
        const responce = await axios.put(`${process.env.REACT_APP_API_URL}/testcaseAutomation`, payload);
        return responce.data || [];
    } catch (error) {
        console.error("Error updating test case scenario:", error);
        return {
            status: -1,
            error: 'Error updating test case scenario'
        }
    }
}

export async function updateExecutionPlan({testCaseId=null, type="ai", executionSteps=null}) {
    try{
        if(!testCaseId || !executionSteps) return {
            status: -1,
            error: 'Test case ID and executionSteps are required'
        }
        const responce = await axios.put(`${process.env.REACT_APP_API_URL}/testcaseAutomation/excutionPlan`, {
            "testcaseId": testCaseId,
            "type": "ai",
            "steps": executionSteps
        });
        return responce.data || {}
    } catch(error) {
        console.error("Error updating Execution Plan:", error);
        return {
            status: -1,
            error: 'Error updating Execution Plan'
        }
    }
}

export async function updateExecutionDetails({testcaseId=null, executionResult=null, executionSummary=null, status}) {
    try{
        if(!testcaseId || !executionResult || !executionSummary) return {
            status: -1,
            error: "testcaseId, executionSummary, executionResult are required"
        }
        const payload = {
            executionResult: executionResult,
            executionSummary: executionSummary,
            testcaseId: testcaseId
        }
        const responce = await axios.put(`${process.env.REACT_APP_API_URL}/testcaseAutomation/excutionDetails`, payload);
        if(responce?.data?.success){
            return {
                status: 1,
                data: responce?.data?.data || {},
                message: responce?.data?.message
            }    
        }
        return {
            status: -1,
            error: 'Error updating Execution Plan'
        }
    } catch(error) {
        console.error("Error updating Execution Plan:", error);
        return {
            status: -1,
            error: 'Error updating Execution Plan'
        }
    }
}

export async function fetchModulesWithCount({ excludeTestGroupId = null, ast } = {}) {
    try {
        const response = await fetchModulesWithCountApi({ excludeTestGroupId, ast });
        
        // API function returns { status, data: [...], message }
        // where data is already the array of modules
        if (response.status === STATUS.SUCCESS) {
            return response.data || [];
        }
        
        return [];
    } catch (error) {
        console.error("Error fetching modules with count:", error);
        return [];
    }
}

export async function fetchModulesTestRunTestCasesWithCount({testrunId=null}){
    try{
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/testrun/fetchmodule`, {
            params: {
                testrunId: testrunId
            }
        });
        return response.data?.modulesData || [];
    } catch (error) {
        console.error("Error fetching modules test run test cases with count:", error);
        return [];
    }
}

export async function bulkCreateTestCaseApiCall({data}){
    try{
        const response = await bulkCreateTestCase({ testCases: data });
        
        if (response.status === STATUS.SUCCESS) {
            return response.data || {};
        }
        
        return {
            status: -1,
            error: response.error || 'Error bulk creating test cases',
            ...response.data
        };
    } catch (error) {
        console.error(">>>>Error bulk creating test cases:", error);
        return {
            status: -1,
            error: error?.error || error?.message || 'Error bulk creating test cases'
        }
    }
}

export async function loginApiCall({email, password}){
    try{
        const response = await loginApi({email, password});
        if(response.status === STATUS.SUCCESS) {
            return {
                status: 1,
                data: response.data || {}
            };
        }
        return {
            status: -1,
            error: response.error || 'Error logging in'
        };
    } catch (error) {
        console.error("Error logging in:", error);
        return {
            status: -1,
            error: error?.error || 'Error logging in'
        }
    }
}

export async function fetchENVList({projectId=null}){
    try{
        if(!projectId) return {
            status: -1,
            error: 'Project ID is required'
        }
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/testcaseAutomation/envVariableList`, {
            params: {
                projectId: projectId
            }
        });
        if(response?.data?.status){
            return {
                status: 1,
                data: response?.data?.data || {}
            }
        }
        return {
            status: -1,
            error: 'Error fetching ENV List'
        }
    } catch (error) {
        console.error("Error fetching user details:", error);
        return {
            status: -1,
            error: 'Error fetching ENV List'
        }
    }
}

// Test group functions have been moved to src/utils/api/testgroup_apis.js
// Import from there instead: import { getTestGroups, createTestGroup, etc. } from '../../utils/api/testgroup_apis';

// Fetch test cases by module or all for a project
// NOTE: This is a legacy wrapper. The new query system uses executeQuery/executeQueryWithAST directly.
// This function is kept for backward compatibility but should be migrated to use AST-based queries.
export async function fetchTestCasesByModule({ moduleId, projectId, page = 1, pageSize = 25, sortField = 'created_at', sortOrder = 'desc', filterField, filterOperator, filterValue, quickFilter, selectedTestCaseIds }) {
  try {
    // Check for legacy filter parameters and warn/error
    if (filterField || filterOperator || filterValue || quickFilter) {
      console.warn(
        'fetchTestCasesByModule: Legacy filter parameters (filterField, filterOperator, filterValue, quickFilter) are deprecated and will be ignored. ' +
        'Use executeQuery/executeQueryWithAST with AST-based queries instead. ' +
        'See /api/query/query-schema for details.'
      );
      // Note: We don't throw an error here to maintain backward compatibility during migration
      // but the filters will be silently ignored (as documented)
    }

    // getTestCaseList now requires 'ast' parameter (can be null for unfiltered queries)
    // Legacy filter params (filterField, filterOperator, filterValue, quickFilter) are no longer supported
    // For filtered queries, use executeQuery/executeQueryWithAST with AST instead
    const response = await getTestCaseList({
      page,
      pageSize,
      moduleId,
      sortField,
      sortOrder,
      ...(selectedTestCaseIds && { selectedTestCaseIds }),
      ast: null  // Required: pass null for unfiltered queries (legacy compatibility)
    });

    if (response.status === STATUS.SUCCESS) {
      // Return in the format expected by existing code
      return {
        rows: response.data?.rows || [],
        total: response.data?.pagination?.total || response.data?.pagination?.totalItems || 0,
        ...response.data,
      };
    }

    return { rows: [], total: 0 };
  } catch (error) {
    console.error('Error fetching test cases by module:', error);
    return { rows: [], total: 0 };
  }
}

// Test case association functions have been moved to src/utils/api/testgroup_apis.js
// Import from there instead: import { getAvailableTestCasesForGroup, getAssociatedTestCasesForGroup, removeTestCasesFromTestGroup } from '../../utils/api/testgroup_apis';

// DEPRECATED: This function has been moved to src/utils/api/testlaunch_apis.js
// Import from there instead: import { createTestLaunch } from '../../utils/api/testlaunch_apis';
// This function will be removed in a future version.
export async function createTestLaunch({ testgroupId, name, isSequential = true, config = {}, hostname }) {
  console.warn('DEPRECATED: createTestLaunch from api.js is deprecated. Use createTestLaunch from testlaunch_apis.js instead.');
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/testcaseAutomation/createTestLaunch`, {
      testgroupId,
      name,
      isSequential,
      config,
      hostname
    });
    return response.data;
  } catch (error) {
    console.error('Error creating test launch:', error);
    throw error;
  }
}

// Test group detail functions have been moved to src/utils/api/testgroup_apis.js
// Import from there instead: import { getTestGroupById, fetchModulesTestGroupWithCount, getTestGroupSummary, getTestGroupAnalytics } from '../../utils/api/testgroup_apis';

export async function checkExecutionPlanExists({ testCaseId }) {
  try {
    const response = await checkExecutionPlanExistsApi({ testCaseId });
    if (response.status === STATUS.SUCCESS) {
      return response.data?.exists || false;
    }
    return false;
  } catch (error) {
    console.error('Error checking execution plan:', error);
    return false;
  }
}

// DEPRECATED: This function has been moved to src/utils/api/testlaunch_apis.js
// Import from there instead: import { getTestLaunchesForGroup } from '../../utils/api/testlaunch_apis';
// This function will be removed in a future version.
export async function fetchTestLaunchesForGroup({ testGroupId, page = 1, pageSize = 25, search = '', status = 'all' }) {
  console.warn('DEPRECATED: fetchTestLaunchesForGroup from api.js is deprecated. Use getTestLaunchesForGroup from testlaunch_apis.js instead.');
  try {
    const params = { page, pageSize };
    if (search) params.search = search;
    if (status && status !== 'all') params.status = status;
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/test-launch/${testGroupId}/launches`, {
      params
    });
    return response.data || { rows: [], total: 0 };
  } catch (error) {
    console.error('Error fetching test launches for group:', error);
    return { rows: [], total: 0 };
  }
}

/**
 * Fetch a single launch by its ID (with computed fields)
 */
export async function fetchTestLaunchById(launchId) {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/test-launch/launch/${launchId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching test launch by id:', error);
    return null;
  }
}
// Environment API - DEPRECATED: Environment API functions have been moved to src/utils/api/environment_apis.js
// Variable API - DEPRECATED: Variable API functions have been moved to src/utils/api/Variable_apis.js
// Import from those files instead:
// import { fetchEnvironmentList, createEnvironment, updateEnvironment, deleteEnvironment } from './api/environment_apis';
// import { getVariablesList, createVariable, deleteVariable, getEnvironmentVariableList, updateVariableValue, updateEnvironmentVariable, getVariableListData } from './api/Variable_apis';


export async function fetchScreenshotDownloadUrl(screenshot){
    try{
        // URL encode the screenshot file key to handle special characters in the path
        const encodedScreenshot = encodeURIComponent(screenshot);
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/s3/screenshot/${encodedScreenshot}/download-url`);
        if (response.data && response.data.success) {
            return response.data.data; // Return the data object containing fileKey, downloadUrl, expiresIn
        }
        return null;
    } catch (error) {
        console.error("Error fetching screenshot download url:", error);
        return null;
    }
}
export async function fetchExecutionResultList({page=1, pageSize=10, filter,launch_id,addOnFilters}){
     
    try{
        const response = await getExecutionResultApi({
            launchId: launch_id,
            page,
            pageSize,
            filter,
            addOnFilters
        });
        
        if (response.status === STATUS.SUCCESS) {
            return {
                status: 1,
                data: response.data || {},
                message: response.message
            };
        }
        
        return {
            status: -1,
            error: response.error || 'Error fetching execution results'
        };
    } catch (error) {
        console.error("Error fetching execution results:", error);
        return {
            status: -1,
            error: error?.error || error?.message || 'Error fetching execution results'
        }
    }
}     

// DEPRECATED: This function has been moved to src/utils/api/testlaunch_apis.js
// Import from there instead: import { getLaunchDetailsSummary } from '../../utils/api/testlaunch_apis';
// This function will be removed in a future version.
export async function fetchLaunchDetailsSummary({launch_id}){
    console.warn('DEPRECATED: fetchLaunchDetailsSummary from api.js is deprecated. Use getLaunchDetailsSummary from testlaunch_apis.js instead.');
    try{
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/testcaseAutomation/getLaunchDetailsSummary/${launch_id}`,{
        });
        return {
            status: 1,
            data: response?.data || {},
            message: response?.data?.message
        }   
    } catch (error) {
        return {
            status: -1,
            error: error?.response?.data?.message || 'Error fetching variables list'
        }
    }
}     


export async function updateExecutionResultStatus({
    statusToBeUpdated,
    executionResultIds,
    testLaunchId
}) {
    try {
        const response = await updateExecutionResultStatusApi({
            executionResultIds,
            statusToBeUpdated,
            testLaunchId
        });
        
        if (response.status === STATUS.SUCCESS) {
            return {
                status: 1,
                data: response.data || {},
                message: response.message
            };
        }
        
        return {
            status: -1,
            error: response.error || 'Error updating execution result status'
        };
    } catch (error) {
        console.error("update Execution Result Status:", error);
        return {
            status: -1,
            error: error?.error || error?.message || 'Error updating execution result status'
        };
    }
}

// DEPRECATED: This function has been moved to src/utils/api/testlaunch_apis.js
// Import from there instead: import { fetchExecutionDetails } from '../../utils/api/testlaunch_apis';
// This function will be removed in a future version.
export async function fetchExecutionDetails({executionResultId}){
    console.warn('DEPRECATED: fetchExecutionDetails from api.js is deprecated. Use fetchExecutionDetails from testlaunch_apis.js instead.');
    try{
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/test-launch/fetchExecutionDetails/${executionResultId}`,{
        });
        return {
            status: 1,
            data: response?.data || {},
            message: response?.data?.message
        }   
    } catch (error) {
        return {
            status: -1,
            error: error?.response?.data?.message || 'Error fetching variables list'
        }
    }
}     


// DEPRECATED: This function has been moved to src/utils/api/testlaunch_apis.js
// Import from there instead: import { reExecuteTestcase } from '../../utils/api/testlaunch_apis';
// This function will be removed in a future version.
export async function rerunTestCaseInLaunch({ executionResultId }) {
    console.warn('DEPRECATED: rerunTestCaseInLaunch from api.js is deprecated. Use reExecuteTestcase from testlaunch_apis.js instead.');
    try {
     const response =   await axios.post(`${process.env.REACT_APP_API_URL}/test-launch/re-execute-testcase`, {
            executionResultId,
        });
        return {
            status: 1,
            data: response?.data?.data || {},
            message: response?.data?.message
        }
    } catch (error) {
        console.error('Error executing test case:', error);
        return {
            status: -1,
            error: error?.response?.data?.message || 'Error executing test case'
        };
    }
}

export async function createTestCase(formData) {
  try {
    const projectId = getProjectId();
    if (!projectId) {
      throw new Error("Project ID is required");
    }
    
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/${projectId}/testcase/create`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
        withCredentials: true
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function updateTestCase(testCaseId, formData) {
  try {
    const projectId = getProjectId();
    if (!projectId) {
      throw new Error("Project ID is required");
    }
    
    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/${projectId}/testcase/${testCaseId}`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
        withCredentials: true
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function updateTestCaseField(testCaseId, field, value, updatedBy) {
  try {
    const response = await updateTestCaseFieldApi({
      testCaseId,
      field,
      value,
      updated_by: updatedBy
    });
    
    if (response.status === STATUS.SUCCESS) {
      return response.data;
    }
    
    throw new Error(response.error || 'Error updating test case field');
  } catch (error) {
    throw error;
  }
}

export async function fetchAttachmentDownloadUrl(attachmentFileKey) {
  try {
    const encodedAttachmentFileKey = encodeURIComponent(attachmentFileKey);
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/s3/attachment/${encodedAttachmentFileKey}/download-url`);
    
    if (response.data && response.data.success) {
      return response.data.data;
    }
    return null;
  } catch (error) {
    console.error("Error fetching attachment download url:", error);
    return null;
  }
}

// This function now uses the new attachment_apis module
export async function fetchAttachmentsByIds(attachmentIds) {
  const { getAttachmentsByIds } = require('./api/attachment_apis');
  const { STATUS } = require('./api/sharedfunction');
  
  try {
    const response = await getAttachmentsByIds({ attachmentIds });
    if (response.status === STATUS.SUCCESS) {
      return response.data || [];
    }
    return [];
  } catch (error) {
    console.error("Error fetching attachments by IDs:", error);
    return [];
  }
}


export async function fetchExecutionResultOnTestCaseId({page=1, pageSize=10, filter,testCaseId}){
    try{
        const response = await fetchExecutionHistory({
            testCaseId,
            page,
            pageSize
        });
        
        if (response.status === STATUS.SUCCESS) {
            return {
                status: 1,
                data: response.data || {}, 
                message: response.message
            };
        }
        
        return {
            status: -1,
            error: response.error || 'Error fetching execution history list !!!'
        };
    } catch (error) {
        return {
            status: -1,
            error: error?.error || error?.message || 'Error fetching execution history list !!!'
        }
    }
}  

export async function deleteTestCase({ ids } = {}) {
    try {
        const response = await deleteTestCaseApi({ ids });
        
        if (response.status === STATUS.SUCCESS) {
            return response.data;
        }
        
        throw new Error(response.error || 'Error deleting test case(s)');
    } catch (error) {
        throw error;
    }
}

export async function cloneTestCase({ targetModuleId, testCaseId, testCaseIds } = {}) {
    try {
        const response = await cloneTestCaseApi({ targetModuleId, testCaseId, testCaseIds });
        
        if (response.status === STATUS.SUCCESS) {
            return response.data;
        }
        
        throw new Error(response.error || 'Error cloning test case(s)');
    } catch (error) {
        throw error;
    }
}

export async function moveTestCase({ targetModuleId, testCaseId, testCaseIds } = {}) {
    try {
        const response = await moveTestCaseApi({ targetModuleId, testCaseId, testCaseIds });
        
        if (response.status === STATUS.SUCCESS) {
            return response.data;
        }
        
        throw new Error(response.error || 'Error moving test case(s)');
    } catch (error) {
        throw error;
    }
}

export async function refreshUserSessionApiCall(){
    try{
        const response = await refreshSessionApi();
        if (response.status === STATUS.SUCCESS) {
            return {
                status: 1,
                data: response.data,
                message: response.message
            };
        } else {
            return {
                status: -1,
                error: response.error || 'Session refresh failed'
            };
        }
    } catch (error) {
        console.error('Session refresh failed:', error);
        return {
            status: -1,
            error: error?.error || error?.message || 'Session refresh failed'
        };
    }
}  

export async function uploadScreenshot({base64Screenshot, executionResultId, stepIndex}){
    try{
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/s3/upload-screenshot`, {
            base64Screenshot, 
            executionResultId, 
            stepIndex, 
        });
        return {
            status: 1,
            data: response?.data?.data || {},
            message: response?.data?.message
        }
    } catch (error) {
        return {
            status: -1,
            error: error?.response?.data?.message || 'Error uploading screenshot'
        }
    }
}

// autoGenerateUniqueProjectPrefix removed - use generateUniquePrefixForProject from project_apis.js directly

export async function fetchTestCaseDetails({testCaseId, lastExecutionResultStatus}){
    try{
        const response = await getTestCaseDetail({ testCaseId, lastExecutionResultStatus });
        
        if (response.status === STATUS.SUCCESS) {
            return {
                status: 1,
                data: response.data || {},
                message: response.message
            };
        }

        return {
            status: -1,
            error: response.error || 'Error fetching Test case details !!!'
        };
    } catch (error) {
        return {
            status: -1,
            error: error?.error || error?.message || 'Error fetching Test case details !!!'
        }
    }
}


// Direct S3 upload functions 
export async function getPresignedUploadUrl(fileName, fileType, fileSize, orgId, projectId) {
    try {
        const response = await axios.post('/s3/presigned-upload-url', {
            fileName,
            fileType,
            fileSize,
            orgId,
            projectId
        });
        
        return {
            status: 1,
            data: response?.data?.data || response?.data,
            message: response?.data?.message || 'Pre-signed URL generated successfully'
        };
    } catch (error) {
        console.error('Error getting pre-signed URL:', error);
        return {
            status: -1,
            error: error?.response?.data?.message || 'Failed to get upload URL'
        }
    }
}
// export async function setCurrentProject({projectId, dispatch}){
//     try{
//         if(!projectId) return {
//             status: -1,
//             error: "Project ID is required"
//         };
//         const response = await axios.post(`${process.env.REACT_APP_API_URL}/user/setProject`, {projectId});
//         dispatch(selectProject(response?.data?.project || {}));
//         dispatch(resetAllState());
//         return {
//             status: 1,
//             message: "Project set successfully"
//         };
//     } catch (error) {
//         console.error("Error setting current project:", error);
//         window.location.href = '/';
//         return {
//             status: -1,
//             error: error?.response?.data?.message || 'Error setting current project'
//         };
//     }
// }

// fetchProjectDetails removed - use getProjectInfo from project_apis.js directly
// createProject removed - use createProject from project_apis.js directly
// updateProject removed - use updateProject from project_apis.js directly
// deleteProject removed - use deleteProject from project_apis.js directly

export async function uploadFileDirectlyToS3(file, presignedData, onUploadProgress) {
    try {
        const formData = new FormData();

        // Presigned POST fields (key, policy, signature, Content-Type, tagging, etc.) must
        // appear before the file part. Do not duplicate Content-Type — it is already in fields.
        Object.keys(presignedData.fields).forEach((key) => {
            formData.append(key, presignedData.fields[key]);
        });

        formData.append('file', file);

        // Do not set Content-Type manually: multipart/form-data requires a boundary; axios
        // sets it automatically for FormData. A bare "multipart/form-data" breaks S3 POST (403).
        const response = await axios.post(presignedData.uploadUrl, formData, {
            onUploadProgress: onUploadProgress,
        });

        return {
            success: true,
            fileKey: presignedData.fileKey,
            response: response,
        };
    } catch (error) {
        console.error('Error uploading file directly to S3:', error);
        console.error('Error response:', error.response?.data);
        return {
            success: false,
            error: error.message || 'Direct upload failed',
        };
    }
}

export async function confirmDirectUpload(tempFileKey, testCaseId, orgId, projectId) {
    try {
        const response = await axios.post('/s3/confirm-direct-upload', {
            tempFileKey,
            testCaseId,
            orgId,
            projectId
        });
        
        return {
            status: 1,
            data: response?.data?.data || response?.data,
            message: response?.data?.message || 'Upload confirmed successfully'
        };
    } catch (error) {
        console.error('Error confirming direct upload:', error);
        return {
            status: -1,
            error: error?.response?.data?.message || 'Failed to confirm upload'
        };
    }
}

// fetchLabels removed - use getAllLabels from label_apis.js directly


// DEPRECATED: This function has been moved to src/utils/api/testlaunch_apis.js
// Import from there instead: import { updateTestLaunchStatus } from '../../utils/api/testlaunch_apis';
// This function will be removed in a future version.
// Note: The new function uses different parameter names: { launchId, status } instead of { testLaunchId, statusToBeUpdated }
export async function updateTestLaunchStatus({
    statusToBeUpdated,
    testLaunchId
}) {
    console.warn('DEPRECATED: updateTestLaunchStatus from api.js is deprecated. Use updateTestLaunchStatus from testlaunch_apis.js instead.');
    try {
        const response = await axios.patch(
            `${process.env.REACT_APP_API_URL}/testcaseAutomation/status/${testLaunchId}`,
            {
                status: statusToBeUpdated
            }
        );
        return {
            status: 1,
            data: response?.data?.data || {},
            message: response?.data?.message
        }
    } catch (error) {
        console.error("update Test Launch Status:", error);
        return {
            status: -1,
            error: error?.response?.data?.message || 'Error updating status of Test Launch'
        };
    }
}

// DEPRECATED: This function has been moved to src/utils/api/testlaunch_apis.js
// Import from there instead: import { abortExecution } from '../../utils/api/testlaunch_apis';
// This function will be removed in a future version.
export async function abortExecution({
    executionResultId
}) {
    console.warn('DEPRECATED: abortExecution from api.js is deprecated. Use abortExecution from testlaunch_apis.js instead.');
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/testcaseAutomation/abortExecution`,
            {
                executionResultId
            }
        );
        return {
            status: 1,
            data: response?.data?.data || {},
            message: response?.data?.message || 'Execution aborted successfully'
        }
    } catch (error) {
        console.error("abortExecution:", error);
        return {
            status: -1,
            error: error?.response?.data?.message || 'Error aborting execution'
        };
    }
}

export async function updateExecutionRecord({testCaseId, plan, dynamicResult}) {
    if(!testCaseId || !plan) return {
        status: -1,
        error: 'Test case ID and plan are required'
    }
    try {
        const response = await updateExecutionRecordApi({ testCaseId, plan, dynamicResult });
        
        if (response.status === STATUS.SUCCESS) {
            return {
                status: 1,
                data: response.data || {},
                message: response.message
            };
        }
        
        return {
            status: -1,
            error: response.error || 'Error updating Execution Record'
        };
    } catch (error) {
        console.error("Error updating Execution Record:", error);
        return {
            status: -1,
            error: error?.error || error?.message || 'Error updating Execution Record'
        }
    }
}

export async function fetchExecutionRecord({testCaseId}){
    try{
        if(!testCaseId) return {
            status: -1,
            error: 'Test case ID is required'
        }
        const response = await getAutomationInstructionApi({ id: testCaseId });
        
        if (response.status === STATUS.SUCCESS) {
            return {
                status: 1,
                data: response.data || {},
                message: response.message
            };
        }
        
        return {
            status: -1,
            error: response.error || 'Error fetching Execution Record'
        };
    } catch(error) {
        console.error("Error fetching Execution Record:", error);
        return {
            status: -1,
            error: error?.error || error?.message || 'Error fetching Execution Record'
        }
    }
}

export async function updateAutomationInstruction({testCaseId, instruction}) {
    try {
        if(!testCaseId || !instruction) return {
            status: -1,
            error: 'Test case ID and instruction are required'
        }
        const response = await updateAutomationInstructionApi({
            testCaseId,
            automationInstruction: instruction
        });
        
        if (response.status === STATUS.SUCCESS) {
            return {
                status: 1,
                data: response.data || {},
                message: response.message
            };
        }
        
        return {
            status: -1,
            error: response.error || 'Error updating Automation Instruction'
        };
    } catch (error) {
        console.error("Error updating Automation Instruction:", error);
        return {
            status: -1,
            error: error?.error || error?.message || 'Error updating Automation Instruction'
        }
    }
}

export async function saveAutomationInstructionOnly({ testCaseId, instruction }) {
    try {
        if (!testCaseId || !instruction) {
            return {
                status: -1,
                error: 'Test case ID and instruction are required',
            };
        }

        const response = await saveAutomationInstructionOnlyApi({
            testCaseId,
            automationInstruction: instruction,
        });

        if (response.status === STATUS.SUCCESS) {
            return {
                status: 1,
                data: response.data || {},
                message: response.message,
            };
        }

        return {
            status: -1,
            error: response.error || 'Error saving automation instruction only',
        };
    } catch (error) {
        console.error('Error saving automation instruction only:', error);
        return {
            status: -1,
            error: error?.error || error?.message || 'Error saving automation instruction only',
        };
    }
}

export async function checkAutomationInstruction({testCaseId}) {
    try {
        if(!testCaseId) return {
            status: -1,
            error: 'Test case ID is required'
        }
        const response = await checkAutomationInstructionApi({ id: testCaseId });
        
        if (response.status === STATUS.SUCCESS) {
            return {
                status: 1,
                data: response.data || false,
                message: response.message
            };
        }
        
        return {
            status: -1,
            error: response.error || 'Error checking Automation Instruction'
        };
    } catch (error) {
        console.error("Error checking Automation Instruction:", error);
        return {
            status: -1,
            error: error?.error || error?.message || 'Error checking Automation Instruction'
        }
    }
}

export async function getExecutionRecordSteps({testCaseId=null}) {
    try {
        if(!testCaseId) return {
            status: -1,
            error: 'Test case ID is required'
        }
        const response = await getExecutionRecordApi({ id: testCaseId });
        
        if (response.status === STATUS.SUCCESS) {
            return {
                status: 1,
                data: response.data || {},
                message: response.message
            };
        }
        
        return {
            status: -1,
            error: response.error || 'Error getting Execution Record Steps'
        };
    } catch (error) {
        console.error("Error getting Execution Record Steps:", error);
        return {
            status: -1,
            error: error?.error || error?.message || 'Error getting Execution Record Steps'
        }
    }
}
  
export async function fetchMCPToolsList({ url } = {}) {
    try {
        const apiUrl = url? url : process.env.REACT_APP_WS_URL;
        const finalUrl = process.env.REACT_APP_WS_URL?.includes('localhost') ? `${apiUrl}/api/mcp-tools` : `${apiUrl}/test-automation/api/mcp-tools`;
        // const response = await axios.get(`${apiUrl}/test-automation/api/mcp-tools`);
        // const response = await axios.get(`${apiUrl}/api/mcp-tools`);
        const response = await axios.get(finalUrl);

        if(response?.data?.success){
            return {
                status: 1,
                data: response.data?.tools || [],
                message: response.data?.message || 'MCP Tools fetched successfully'
            }
        }
    } catch (error) {
        console.error("Error fetching MCP Tools:", error);
        return {
            status: -1,     
            error: 'Error fetching MCP Tools'
        }
    }
}

// DEPRECATED: fetchAutomationModels has been moved to src/utils/api/aimodel_apis.js
// Import from there instead: import { fetchAutomationModels } from './api/aimodel_apis';
// This function will be removed in a future version.
/** @param {{ projectId?: string, section?: string }} [params] — forwarded to aimodel_apis (same shape). */
export async function fetchAutomationModels(params = {}) {
    console.warn('DEPRECATED: fetchAutomationModels from api.js is deprecated. Use fetchAutomationModels from aimodel_apis.js instead.');
    const { fetchAutomationModels: fetchAutomationModelsApi } = require('./api/aimodel_apis');
    try {
        const response = await fetchAutomationModelsApi(params);
        if (response.status === STATUS.SUCCESS) {
            return {
                status: 1,
                data: response.data || [],
                message: response.message || 'Automation Models fetched successfully'
            };
        }
        return {
            status: -1,
            error: response.error || 'Error fetching Automation Models'
        };
    } catch (error) {
        console.error("Error fetching Automation Models:", error);
        return {
            status: -1,
            error: error?.error || error?.message || 'Error fetching Automation Models'
        };
    }
}

// fetchNLPConfiguration and updateNLPConfiguration removed - use functions from api/nlp-configuration_apis.js directly

// fetchOrganizationServiceUrl removed - use getOrganizationServiceUrl from organization_apis.js directly
import { getOrganizationServiceUrl as getOrgServiceUrl } from "./api/organization_apis";

export async function fetchOrganizationServiceUrl() {
    try {
        const response = await getOrgServiceUrl();
        if (response.status === STATUS.SUCCESS) {
            return {
                status: 1,
                data: response.data
            };
        }
        return {
            status: -1,
            message: response.error || 'Failed to fetch organization service URL'
        };
    } catch (error) {
        console.error('Error fetching organization service URL:', error);
        return {
            status: -1,
            message: error?.error || error?.message || 'An error occurred while fetching organization service URL'
        };
    }
}

async function getNotificationData(path, params) {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/notification/${path}`, { params });

    if (!response.data?.success) {
        throw new Error(response.data?.message || 'Notification request failed');
    }

    return response.data.data;
}

export async function getUnreadCount() {
    return getNotificationData('unread-count');
}

export async function listNotifications({ cursor = null, pageSize = 20 } = {}) {
    const page = Number(cursor) || 1;
    const data = await getNotificationData('list', { page, pageSize });
    const hasNextPage = data.page * data.pageSize < data.total;

    return {
        items: data.items || [],
        nextCursor: hasNextPage ? String(data.page + 1) : null,
    };
}

export async function markNotificationAsRead(recipientId) {
    const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}/notification/${recipientId}/read`
    );

    if (!response.data?.success) {
        throw new Error(response.data?.message || 'Unable to mark notification as read');
    }

    return response.data.data;
}

export async function markAllNotificationsAsRead() {
    const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/notification/mark-all-read`
    );

    if (!response.data?.success) {
        throw new Error(response.data?.message || 'Unable to mark all notifications as read');
    }

    return response.data.data;
}

// Sheet 1 Insights — separate tables/endpoints from notifications above
// (never mixed into notification_events); rendered in their own drawer
// section (see NotificationPanel.jsx + insightsSlice.js).
async function getInsightsData(path, params) {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/insights/${path}`, { params });

    if (!response.data?.success) {
        throw new Error(response.data?.message || 'Insight request failed');
    }

    return response.data.data;
}

export async function getInsightInbox({ projectId } = {}) {
    const data = await getInsightsData('inbox', projectId ? { projectId } : undefined);
    return data.items || [];
}

export async function getInsightUnreadCount({ projectId } = {}) {
    const data = await getInsightsData('unread-count', projectId ? { projectId } : undefined);
    return data.unreadCount || 0;
}

export async function ackInsight(insightId, fingerprint) {
    const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/insights/ack`,
        { insightId, fingerprint }
    );

    if (!response.data?.success) {
        throw new Error(response.data?.message || 'Unable to acknowledge insight');
    }

    return response.data.data;
}

export async function ackAllInsights({ projectId } = {}) {
    const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/insights/ack-all`,
        projectId ? { projectId } : {}
    );

    if (!response.data?.success) {
        throw new Error(response.data?.message || 'Unable to acknowledge all insights');
    }

    return response.data.data;
}

export async function getProjectWebhookConfig(projectId) {
    return axios.get(`${process.env.REACT_APP_API_URL}/notification/projects/${projectId}/webhook`);
}

export async function updateProjectWebhookConfig(projectId, payload) {
    return axios.put(`${process.env.REACT_APP_API_URL}/notification/projects/${projectId}/webhook`, payload);
}

export async function disableProjectWebhookConfig(projectId) {
    return axios.delete(`${process.env.REACT_APP_API_URL}/notification/projects/${projectId}/webhook`);
}

export async function listProjectWebhookDeliveries(projectId, { page = 1, pageSize = 20 } = {}) {
    const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/notification/projects/${projectId}/webhook/deliveries`,
        { params: { page, pageSize } }
    );

    if (!response.data?.success) {
        throw new Error(response.data?.message || 'Unable to load webhook deliveries');
    }

    return response.data.data;
}

export async function retryProjectWebhookDelivery(deliveryLogId, projectId) {
    const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/notification/webhook/deliveries/${deliveryLogId}/retry`,
        null,
        { params: { projectId } }
    );

    if (!response.data?.success) {
        throw new Error(response.data?.message || 'Unable to retry webhook delivery');
    }

    return response.data.data;
}